/* ======================================================================
   ScrubMe – desktop PDP main media carousel helper
   - Desktop/tablet only: min-width 750px
   - Does not change variant filtering logic
   - Builds desktop dots from the currently visible main media slides
   - Syncs active slide/dot while scrolling or using arrows
   - Avoids binding desktop ResizeObserver/listeners on mobile
   ====================================================================== */
(function () {
  "use strict";

  var desktopMq = window.matchMedia("(min-width: 750px)");

  function visibleSlides(list) {
    if (!list) return [];

    return Array.prototype.filter.call(list.querySelectorAll(".product__media-item.slider__slide"), function (slide) {
      if (!slide) return false;
      if (slide.getAttribute("data-scrubme-hidden") === "1") return false;
      if (slide.style && slide.style.display === "none") return false;
      return slide.offsetWidth > 0;
    });
  }

  function slideToken(slide) {
    if (!slide) return "";
    return slide.getAttribute("data-media-id") || (slide.dataset ? slide.dataset.mediaId : "") || "";
  }

  function setActive(gallery, slide) {
    if (!gallery || !slide) return;

    var list = gallery.querySelector('[id^="Slider-Gallery-"]');
    var dots = gallery.querySelectorAll('[id^="GalleryDots-"] .scrubme-dots__dot');
    var token = slideToken(slide);

    if (list) {
      list.querySelectorAll(".product__media-item[data-media-id]").forEach(function (item) {
        item.classList.toggle("is-active", item === slide);
      });
    }

    dots.forEach(function (dot) {
      var active = dot.getAttribute("data-media-id") === token;

      if (active) {
        dot.setAttribute("aria-current", "true");
      } else {
        dot.removeAttribute("aria-current");
      }
    });

    var thumbs = gallery.querySelectorAll(".thumbnail-list__item");

    thumbs.forEach(function (thumb) {
      var thumbTarget = thumb.getAttribute("data-target") || "";
      var active = thumbTarget === token;
      var button = thumb.querySelector("button");

      thumb.classList.toggle("is-active", active);

      if (!button) return;

      if (active) {
        button.setAttribute("aria-current", "true");
      } else {
        button.removeAttribute("aria-current");
      }
    });
  }

  function closestSlide(list, slides) {
    if (!list || !slides.length) return null;

    var scrollLeft = list.scrollLeft || 0;
    var closest = slides[0];
    var closestDistance = Math.abs(slides[0].offsetLeft - scrollLeft);

    for (var i = 1; i < slides.length; i++) {
      var distance = Math.abs(slides[i].offsetLeft - scrollLeft);

      if (distance < closestDistance) {
        closest = slides[i];
        closestDistance = distance;
      }
    }

    return closest;
  }

  function refreshSliderComponent(viewer) {
    try {
      if (viewer && typeof viewer.resetPages === "function") {
        viewer.resetPages();
      }
    } catch (e) {}
  }

  function buildDots(gallery) {
    if (!desktopMq.matches) return;
    if (!gallery) return;

    var dotsContainer = gallery.querySelector('[id^="GalleryDots-"]');
    var viewer = gallery.querySelector('slider-component[id^="GalleryViewer-"]');
    var list = gallery.querySelector('[id^="Slider-Gallery-"]');

    if (!dotsContainer || !viewer || !list) return;

    var slides = visibleSlides(list);

    dotsContainer.style.display = "";
    dotsContainer.innerHTML = "";

    if (slides.length <= 1) return;

    slides.forEach(function (slide, index) {
      var dot = document.createElement("button");

      dot.type = "button";
      dot.className = "scrubme-dots__dot";
      dot.setAttribute("aria-label", "Go to image " + (index + 1));
      dot.setAttribute("data-media-id", slideToken(slide));

      dot.addEventListener("click", function () {
        setActive(gallery, slide);

        try {
          list.scrollTo({ left: slide.offsetLeft, behavior: "smooth" });
        } catch (e) {
          list.scrollLeft = slide.offsetLeft;
        }
      });

      dotsContainer.appendChild(dot);
    });

    refreshSliderComponent(viewer);
    setActive(gallery, closestSlide(list, slides) || slides[0]);
  }

  function initGallery(gallery) {
    if (!desktopMq.matches) return;
    if (!gallery || gallery.__scrubmeDesktopCarouselBound) return;

    gallery.__scrubmeDesktopCarouselBound = true;

    var list = gallery.querySelector('[id^="Slider-Gallery-"]');
    var viewer = gallery.querySelector('slider-component[id^="GalleryViewer-"]');

    if (!list || !viewer) return;

    var scrollScheduled = false;

    list.addEventListener(
      "scroll",
      function () {
        if (!desktopMq.matches) return;
        if (scrollScheduled) return;

        scrollScheduled = true;

        window.requestAnimationFrame(function () {
          scrollScheduled = false;

          var slides = visibleSlides(list);
          var active = closestSlide(list, slides);

          if (active) {
            setActive(gallery, active);
          }
        });
      },
      { passive: true }
    );

    viewer.addEventListener("slideChanged", function (event) {
      if (!desktopMq.matches) return;

      var current = event && event.detail ? event.detail.currentElement : null;

      if (current) {
        setActive(gallery, current);
      }
    });

    if ("ResizeObserver" in window) {
      var ro = new ResizeObserver(function () {
        if (!desktopMq.matches) return;

        window.requestAnimationFrame(function () {
          buildDots(gallery);
        });
      });

      ro.observe(list);
      gallery.__scrubmeDesktopCarouselRO = ro;
    }

    buildDots(gallery);
  }

  function hideDesktopDotsOnMobile() {
    document.querySelectorAll('[id^="GalleryDots-"]').forEach(function (dots) {
      dots.innerHTML = "";
      dots.style.display = "none";
    });
  }

  function refreshAll() {
    if (!desktopMq.matches) {
      hideDesktopDotsOnMobile();
      return;
    }

    document.querySelectorAll("media-gallery").forEach(function (gallery) {
      initGallery(gallery);

      window.requestAnimationFrame(function () {
        buildDots(gallery);
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", refreshAll);
  } else {
    refreshAll();
  }

  document.addEventListener("shopify:section:load", refreshAll);
  document.addEventListener("scrubme:variantMediaFiltered", refreshAll);
  document.addEventListener("variant:change", refreshAll);
  document.addEventListener("variant:changed", refreshAll);
  document.addEventListener("product:variant-change", refreshAll);

  if (desktopMq.addEventListener) {
    desktopMq.addEventListener("change", refreshAll);
  } else if (desktopMq.addListener) {
    desktopMq.addListener(refreshAll);
  }
})();